"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.editablePageColumns = exports.editablePageEntityName = void 0;
const storage_1 = require("@juvare/platform-shared/features/storage");
exports.editablePageEntityName = 'editablePage';
exports.editablePageColumns = (0, storage_1.defineColumns)({
    url: {
        type: 'string-required',
        index: 'unique',
    },
    order: {
        type: 'number-required',
        index: true,
    },
    label: {
        type: 'string-required',
        index: true,
    },
    active: {
        type: 'boolean-required',
        index: true,
    },
    tags: {
        type: 'string-array-required',
        index: true,
    },
    search: {
        type: 'full-text-search-required',
        language: 'english',
    },
});
